import React, { FC, useCallback, useEffect, useState } from 'react';
import { Switch, Typography } from 'antd';

type Props = {
  value?: boolean;
  onChange?: (value: boolean) => void;
  autoEnable?: boolean;
};

const { Text } = Typography;

const VisibilitySwitch: FC<Props> = ({ value, onChange, autoEnable }) => {
  const [checked, setChecked] = useState(value ?? false);

  useEffect(() => {
    setChecked(value ?? false);
  }, [value]);

  const onValueChange = useCallback(
    (newChecked: boolean) => {
      if (autoEnable && newChecked) {
        return;
      }
      setChecked(newChecked);
      onChange?.(newChecked);
    },
    [autoEnable, onChange],
  );

  return (
    <div>
      <Switch id={'profile-visibility-switch'} checked={checked} onChange={onValueChange} />
      {checked ? (
        <Text className="text-[14px] ml-6">
          <strong>Current Status:</strong> Restricted
        </Text>
      ) : (
        <Text className="text-[14px] ml-6">
          <strong>Current Status:</strong> Anyone
        </Text>
      )}
    </div>
  );
};

export default VisibilitySwitch;
